// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"9832ce63","369":"e9b1a7e4","566":"e9b1a7e4","666":"e9b1a7e4","848":"e3f90e3f"}[chunkId] + ".chunk.css";
};